import {
  SwitchCard,
  SwitchCardSwitch,
  SwitchCardContent,
  SwitchCardLabel,
} from "@/components/ui/switch-card";
import { Spinner } from "@/components/ui/spinner";

interface CreatorPortalToggleProps {
  includeCreatorPortal: boolean;
  onToggle: (value: boolean) => void;
  isLoading: boolean;
  className?: string;
}

export function CreatorPortalToggle({
  includeCreatorPortal,
  onToggle,
  isLoading,
  className = "",
}: CreatorPortalToggleProps) {
  return (
    <SwitchCard
      className={`hidden cursor-pointer ${className}`}
      onClick={() => onToggle(!includeCreatorPortal)}
    >
      {isLoading && (
        <div className="absolute inset-0 z-10 flex rounded-[inherit] items-center justify-center bg-background/5 backdrop-blur-xs">
          <Spinner className="mr-2" /> Loading...
        </div>
      )}
      <SwitchCardSwitch
        id="includeCreatorPortal"
        checked={includeCreatorPortal || false}
        className="pointer-events-none"
        aria-describedby="includeCreatorPortal-description"
      />
      <SwitchCardContent>
        <SwitchCardLabel htmlFor="includeCreatorPortal">
          Include Uplodio's Creator Portal - To view brief and upload content.
        </SwitchCardLabel>
        <div
          id="includeCreatorPortal-description"
          className="text-muted-foreground text-xs text-start space-y-1"
        >
          <p>
            • Amy sends{" "}
            <span className="underline underline-offset-2 font-medium">
              https://creators.uplodio.com
            </span>{" "}
            to the creator with a{" "}
            <span className="underline underline-offset-2 font-medium">
              unique passkey
            </span>{" "}
          </p>
          <p>• They can upload their content and see the brief.</p>
          <p>
            • See and review the content in the{" "}
            <span className="underline underline-offset-2 font-medium">
              Drafts tab
            </span>
          </p>
        </div>
      </SwitchCardContent>
    </SwitchCard>
  );
}
